export default function initSectorsGrid() {
    // ==========================================================
    // SECTORS GRID — ACTIVE CARD
    // ==========================================================

    const sectorsGrids = document.querySelectorAll("[data-sectors-grid]");

    sectorsGrids.forEach((section) => {
        const cardsContainer = section.querySelector("[data-sectors-cards]");

        const cards = section.querySelectorAll("[data-sector-card]");

        if (!cardsContainer || !cards.length) {
            return;
        }

        const desktopMedia = window.matchMedia("(min-width: 1300px)");

        /**
         * Active une carte et ferme toutes les autres.
         */
        const activateCard = (activeCard) => {
            cards.forEach((card) => {
                card.classList.toggle("is-active", card === activeCard);
            });
        };

        /**
         * Remet la première carte ouverte.
         */
        const resetCards = () => {
            cards.forEach((card, index) => {
                card.classList.toggle("is-active", index === 0);
            });
        };

        /**
         * Hover sur une carte.
         */
        cards.forEach((card) => {
            card.addEventListener("mouseenter", () => {
                if (!desktopMedia.matches) {
                    return;
                }

                activateCard(card);
            });
        });

        /**
         * Quand on quitte complètement la zone,
         * on remet la première carte.
         */
        cardsContainer.addEventListener("mouseleave", () => {
            if (!desktopMedia.matches) {
                return;
            }

            resetCards();
        });

        /**
         * État initial.
         */
        resetCards();
    });
    ("");
}
